exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tagInput{padding:2px;padding-left:20px;background-image:url(" + require("./tags.gif") + ");background-position:2px 2px;background-repeat:no-repeat}.tagInput,.tagInputDiv{border:1px solid #d3d3d3}.tagInputDiv{display:none;background-color:#fff;position:absolute;overflow:auto;margin-top:-1px;font:13px/15px arial,sans-serif}.tagInputLine{color:#000;font-weight:400;padding:4px}.tagInputSel{background-color:gray;color:#fff}.tagInputLineTag{min-width:150px;display:inline-block}.tagInputLineFreq{min-width:50px;text-align:right;display:inline-block;float:right}.tagInputSuggestedTags{font-size:12px;background-color:#e0e0e0;padding:2px;font:13px/15px arial,sans-serif;margin-top:5px;width:550px;color:#303030}.tagInputSuggestedTags .label{font-weight:bolder}.tagInputSuggestedTagList .tag{padding:2px;cursor:pointer;display:inline-block;margin:1px}.tagInputSuggestedTagList span.tag:hover{background-color:#f0f0f0}.tagInputSuggestedTagList .tagUsed{background-color:#d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./source/javascripts/vendor/admin/vendor/tagInput/jquery.tagInput.css
// module id = 547
// module chunks = 7 8 9 10